import { RolesEntity } from '@/domain/entities/roles';
import { RolesPayLoad } from '@/domain/ports/roles/payloads';
import { useEffect, useState } from 'react';
import { UseFormReset } from 'react-hook-form';

type RolePermissions = NonNullable<RolesEntity['permissions']>;

const useWatchPermission = (
  watchPermissions: RolePermissions | undefined,
  detailRole: Pick<RolesEntity, 'permissions'>,
  showId: string | null,
  defaultValue: RolesPayLoad,
  reset: UseFormReset<RolesPayLoad>,
  openForm: boolean,
  isDuplicate = false,
) => {
  const shouldPrefillFromDetail = Boolean(showId) || isDuplicate;
  const detailPermissions = detailRole?.permissions;

  useEffect(() => {
    if (!shouldPrefillFromDetail) {
      reset(defaultValue);
    }
  }, [openForm, shouldPrefillFromDetail, reset]);

  const [listItemChecked, setListItemChecked] = useState<RolePermissions | undefined>(
    shouldPrefillFromDetail ? detailPermissions : watchPermissions,
  );

  useEffect(() => {
    if (shouldPrefillFromDetail) {
      setListItemChecked(detailPermissions);
    } else {
      setListItemChecked(watchPermissions);
    }
  }, [shouldPrefillFromDetail, detailPermissions, watchPermissions]);

  const selectedPermissions = {
    selectedPermissions: shouldPrefillFromDetail ? detailPermissions : [''],
    listItemChecked: listItemChecked,
    setListItemChecked,
  };

  return {
    selectedPermissions,
  };
};

export default useWatchPermission;
